export const INSIGHT_PERMISSION_ACTION_SUBJECT_ID = 'check-insight-permission';
